import React, { useEffect } from "react";
import Script from "next/script";
import Layout from "components/Layout";
import landingStyles from "./landing.module.less";
import HomeGuide from "@/components/Pages/Home/HomeGuide";
import AppAd from "@/components/Pages/Home/AppAd";
import HomeBanner from "@/components/Pages/Home/HomeBanner";
import HomeMarket from "@/components/Pages/Home/HomeMarket";
import HomeDownload from "@/components/Pages/Home/HomeDownload";
import { get_tdk } from "api/server/tdk";
import {Util,Context} from "@xt/xtbase";
const {XtContext} = Context;
const {getOrigin} = Util;

export default function LandingPage(props) {
  const [appState] = React.useContext(XtContext);
  const {lang, theme} = appState;
  const addMove = function (className) {
    if (document.querySelector(className)) {
      document.querySelector(className).classList.add("slideInUpNew");
    }
  };
  const removeMove = function (className) {
    if (document.querySelector(className)) {
      document.querySelector(className).classList.remove("slideInUpNew");
    }
  };
  const scrolObj = {
    "home-guide-container": [".home-guide-container-step"],
    "market-group-container": [".market-group-container-view"],
    "app-download-container": [".app-download-container-load", ".scroll-up-download"],
  };

  const intersectionObserver = () => {
    //初始化一个实例
    let observer = new IntersectionObserver((changes) => {
      for (const change of changes) {
        const container = change.target;
        if (container.className) {
          const classNameFirst = container.className.split(" ")[0];
          const className = classNameFirst ? scrolObj[classNameFirst] : "";
          className &&
            className.forEach((item) => {
              if (change.intersectionRatio > 0.0002) {
                addMove(item);
              } else if (change.intersectionRatio === 0) {
                removeMove(item);
              }
            });
        }
      }
    }, {});
    return observer;
  }
  const scrollList = [".home-guide-container", ".market-group-container", ".app-download-container"];
  useEffect(()=>{
    // const observer = intersectionObserver();
    // scrollList.forEach((item) => {
    //   observer.observe(document.querySelector(item));
    // });
    if (window.zE) {
      const obj = {
        en: "en-us",
        ja: "ja",
        hi: "hi",
        id: "id",
        ru: "ru",
        es: "es-es",
        tr: "tr",
        "zh-HK": "zh-tw",
        "zh-CN": "zh-cn",
        vi: "vi",
        th: "th",
      };
      try {
        zE("webWidget", "setLocale", obj[lang] || "en-us");
      } catch (e) {}
    }
  },[]);
  return (
    <>
      <Layout isShowFoot={true} useBottomBar={false} disablePcMobileTip landingNav>
        <div className={landingStyles.landingRoot}>
          <div className={`home_main ${landingStyles.landingPc}`}>
            <HomeBanner recommendData={props.recommendData} variant="landing" />
            <HomeMarket landingMarketBar />
            <HomeGuide/>
            <HomeDownload appList={props.appList}/>
            <AppAd/>
          </div>
        </div>
      </Layout>
    </>
  );
}
export async function getStaticProps(context){
  const resolvedUrl = "";
  const props = {resolvedUrl:"/"};
  try{
    const tdkUrl = getOrigin("www") + "/" + context.locale + resolvedUrl;
    const tdk = await get_tdk({
      params: {
        url: tdkUrl,
        languageType: context.locale == "zh-CN" ? "cn" : context.locale == "zh-HK" ? "hk" : context.locale
      },
    });
    props.tdk = tdk || {};
  }
  catch(error)
  {
    console.log("get tdk error");
    console.log(error);
    props.tdk = {};
  }
  /*
  try{
    props.recommendData = await get_recommend_symbol();
  }
  catch(error)
  {
    console.log("get recommendData error");
    console.log(error);
  }*/
  return {
    props,
    revalidate:60
  }
}
